<template>
  <div>
    <div class="header">
      <span>营收统计</span>
      <el-form :inline="true" class="header-right">
        <el-form-item>
          <el-radio-group v-model="dateRadio" size="mini" @change="dateRadioChange">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="time"
            :type="dateType"
            size="mini"
            placeholder="时间选择"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border v-loading.body="loading" stripe style="width: 100%;">
      <el-table-tree-column
        parentKey="pid"
        treeKey="oid"
        file-icon="icon icon-file"
        folder-icon="icon icon-folder"
        prop="oname"
        label="组织"
        width="200">
      </el-table-tree-column>
      <el-table-column prop="mzzfy" label="门诊(万元)" sortable></el-table-column>
      <el-table-column prop="mzjcfy" label="门诊均次费用(元)" sortable></el-table-column>
      <el-table-column prop="zyzfy" label="住院(万元)" sortable></el-table-column>
      <el-table-column prop="zyjcfy" label="住院均次费用(元)" sortable></el-table-column>
    </el-table>
  </div>
</template>

<script>
  import _ from 'lodash';
  import moment from 'moment'
  import RevenueCountService from '@/request/count/revenue'
  import ElTreeGrid from 'element-tree-grid'
  import ListUtils from '@/utils/list'
  export default {
    name: "CountRevenue",
    components: {
      'el-table-tree-column': ElTreeGrid
    },
    data() {
      return {
        tableData: [],
        time: moment().startOf('day').valueOf(),
        dateRadio: '日',
        dateType: 'date',
        oids: [],
        loading: true
      }
    },
    props: {
      orgs: {
        type: Array,
        default() {
          return []
        }
      }
    },
    watch: {
      orgs() {
        this.init();
      },
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.loading = true;
        if (this.orgs.length === 0) {
          return
        }
        this.oids = [];
        _.forEach(this.orgs, val => {
          this.oids.push(val.id);
        });
        this.loadOutpatient()
      },
      // 门诊收费
      loadOutpatient() {
        let type = 'day';
        if (this.dateType !== 'date') {
          type = this.dateType
        }
        RevenueCountService.orggroup({
          start: moment(this.time).startOf(type).valueOf(),
          end: moment(this.time).endOf(type).valueOf(),
          oids: this.oids.toString(),
          types: 1
        }).then( res => {
          this.loadInpatient(res.result || [])
        })
      },
      // 住院费用
      loadInpatient(outpatientList) {
        let type = 'day';
        if (this.dateType !== 'date') {
          type = this.dateType
        }
        RevenueCountService.orggroup({
          start: moment(this.time).startOf(type).valueOf(),
          end: moment(this.time).endOf(type).valueOf(),
          oids: this.oids.toString(),
          types: 2
        }).then( res => {
          // 计算 费用 服务端返回分
          _.forEach(outpatientList, val => {
            const index = _.findIndex(res.result || [], {oid: val.oid});
            val.zyzfy = '0.00';
            val.zyjcfy = '0.00';
            val.mzzfy = '0.00';
            val.mzjcfy = '0.00';
            if (index !== -1) {
              if (val.total !== 0) {
                val.mzzfy = (val.total / 1000000).toFixed(2);
                val.mzjcfy = (val.atotal / 100).toFixed(2);
              }
              if (res.result[index].total !== 0) {
                val.zyzfy = (res.result[index].total / 1000000).toFixed(2);
                val.zyjcfy = (res.result[index].atotal / 100).toFixed(2);
              }
            }
          });
          this.data = outpatientList;
          const _tableData = ListUtils.listToTree(this.data, 'oid', 'pid', 'children');
          if (_tableData.length === 1) {
            this.tableData = _tableData[0].children
          } else {
            this.tableData = _tableData
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      // 根据父表格排序, 重新排序子表格
      sortChange(data) {
        const prop = this.columns[_.findIndex(this.columns, {text: data.column.label})].value;
        let order = data.order;
        if (order === 'descending') {
          order = 'desc'
        } else {
          order = 'asc'
        }
        const _tableData = ListUtils.listToTree(_.orderBy(this.data, [prop], [order]), 'oid', 'pid', 'children')
        if (_tableData.length === 1) {
          this.tableData = _tableData[0].children
        } else {
          this.tableData = _tableData
        }
      },
      dateRadioChange(event) {
        switch (event) {
          case '年':
            this.dateType = 'year';
            this.time = moment().startOf('year').valueOf(); // 开始时间
            break;
          case '月':
            this.dateType = 'month';
            this.time = moment().startOf('month').valueOf(); // 开始时间
            break;
          default:
            this.dateType = 'date';
            this.time = moment().startOf('day').valueOf(); // 开始时间
        }
        this.dateChange();
      },
      dateChange(){
        if (this.time) {
          this.loadOutpatient();
        }
      },
      toTree(followupList){
        let result = [], temp = {}, i = 0, j = 0, len = followupList.length;
        for(; i < len; i++){
          temp[followupList[i]['oid']] = followupList[i]; // 以id作为索引存储元素，可以无需遍历直接定位元素
        }
        for(; j < len; j++){
          var currentElement = followupList[j];
          var tempCurrentElementParent = temp[currentElement['pid']]; // 临时变量里面的当前元素的父元素
          if (tempCurrentElementParent) { // 如果存在父元素
            if (!tempCurrentElementParent['children']) { // 如果父元素没有chindren键
              tempCurrentElementParent['children'] = [] // 设上父元素的children键
            }
            tempCurrentElementParent['children'].push(currentElement) // 给父元素加上当前元素作为子元素
          } else { // 不存在父元素，意味着当前元素是一级元素
            result.push(currentElement);
          }
        }
        return result;
      },
    }
  }
</script>

<style scoped>
  .eber-count-table /deep/ .el-table__expanded-cell {
    padding: 0 0 0 48px;
    background-color: #f2f6fc;
  }
  .header {
    height: 50px;
    line-height: 48px;
    color: #000;
    border-bottom: 1px solid #ebeef5;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
  }
  .header-right{
    z-index: 999;
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
  }
</style>
